// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9f26ae5d","77":"36312a40","115":"a66fb7a3","222":"a8d73abf","280":"cda4821e","354":"b0616c38","444":"f9db5d39","510":"a0330be3","563":"11470ce7","567":"62efb8d2","860":"d5aac663","928":"f8a9c84c"}[chunkId] + ".chunk.js";
};